module.exports = __webpack_public_path__ + "static/media/tw.89968289.svg";